import "../../../../../../vue@3.5.18_typescript@5.2.2/node_modules/vue/dist/vue.runtime.esm-bundler.js";
import { onActivated as i, onDeactivated as r } from "../../../../../../@vue_runtime-core@3.5.18/node_modules/@vue/runtime-core/dist/runtime-core.esm-bundler.js";
function d(a) {
  const e = {
    isDeactivated: !1
  };
  let t = !1;
  return i(() => {
    if (e.isDeactivated = !1, !t) {
      t = !0;
      return;
    }
    a();
  }), r(() => {
    e.isDeactivated = !0, t || (t = !0);
  }), e;
}
export {
  d as useReactivated
};



//////////////////
// WEBPACK FOOTER
// ./~/@oppein/op-web-components/dist/es/~/.pnpm/naive-ui@2.42.0_vue@3.5.18/~/naive-ui/es/_utils/composable/use-reactivated.js
// module id = 1623
// module chunks = 67